document.querySelectorAll('[data-password-toggle]').forEach(function (toggle) {
  toggle.addEventListener('click', function () {
    var targetId = toggle.getAttribute('data-password-toggle-target')
    var input = document.getElementById(targetId)
    if (!input) return

    var isPassword = input.getAttribute('type') === 'password'
    input.setAttribute('type', isPassword ? 'text' : 'password')

    toggle.setAttribute('aria-pressed', isPassword ? 'true' : 'false')
    toggle.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password')
  })
})
